export const BASE_URL = 'https://api.ibrahim-magdy.com/'; 